import { forwardRef } from 'react'

const Toggle = forwardRef(function Toggle(
  { checked, onChange, label, disabled = false, ...rest },
  ref
) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 12,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        fontFamily: 'var(--font-body)',
        fontSize: 13,
        color: 'var(--olv-text-primary)',
      }}
    >
      <span
        style={{
          position: 'relative',
          width: 32,
          height: 18,
          borderRadius: 999,
          background: checked ? 'var(--olv-purple)' : 'rgba(255,255,255,0.10)',
          transition: 'background 200ms var(--ease-standard)',
          flexShrink: 0,
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 2,
            left: checked ? 16 : 2,
            width: 14,
            height: 14,
            borderRadius: '50%',
            background: 'white',
            transition: 'left 200ms var(--ease-standard)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.4)',
          }}
        />
      </span>
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
        {...rest}
      />
      {label && <span>{label}</span>}
    </label>
  )
})

export default Toggle
